import {
  GuideCategoryApiRequest,
  UpdateGuideCategoryRequest,
} from '@/data/payload/api/GuideCategoryRequest'
import {
  PostGuideCategoryInterface,
  DeleteGuideCategoryInterface,
  UpdateGuideCategoryInterface,
} from '@/data/payload/contracts/GuideCategoryRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { GuideCategoryDataMapper } from '@/data/persistences/mappers/GuideCategoryDataMapper'
import { GuideCategoryRepositoryInterface } from '@/data/persistences/repositories/contracts/GuideCategoryRepositoryInterface'
import { GuideCategory } from '@/domain/entities/GuideCategory'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class GuideCategoryApiRepository
  implements GuideCategoryRepositoryInterface {
  private service: ApiService
  private mapper: GuideCategoryDataMapper

  constructor(service: ApiService, mapper: GuideCategoryDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async delete(
    payload: DeleteGuideCategoryInterface
  ): Promise<GuideCategory> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.GUIDE_CATEGORY_DELETE,
      undefined,
      payload as GuideCategoryApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(
    payload: PostGuideCategoryInterface
  ): Promise<GuideCategory> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.GUIDE_CATEGORY,
      undefined,
      payload as GuideCategoryApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateGuideCategoryInterface,
    id: number
  ): Promise<GuideCategory> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.GUIDE_CATEGORY}/${id}`,
      undefined,
      payload as UpdateGuideCategoryRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: Object): Promise<GuideCategory> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.GUIDE_CATEGORY,
      params
    )
    return this.mapper.convertFromApi(resp)
  }
}
